export const getStatusColor = (s) => {
  const map = {
    New: 'primary',
    Contacted: 'info',
    Qualified: 'success',
    Connected: 'warning',
    Lost: 'error',
    'Follow up': 'secondary',
    Chatting: 'info',
    Select: 'default',
    Meeting: 'warning',
  };
  return map[s] || 'default';
};

export const formatFileName = (file, index) => {
  return file?.title || file?.file_name || file?.name || `File ${index + 1}`;
};

export const formatFileType = (file, filePath) => {
  return (file?.type || file?.mime_type || filePath?.split('.').pop())?.toUpperCase();
};

export const buildQueryParams = (pagination, filters, sort, noActivity, searchValue) => {
  const params = {
    'relations[]': ['source', 'assignees', 'dba', 'author', 'lastStatusLog', 'attachments', 'meetings', 'issue'],
    paginate: 1,
    page: pagination.page + 1,
    per_page: pagination.pageSize,
    ...(searchValue && { search: searchValue }),
  };

  if (filters.status_id && filters.status_id !== '') {
    params['status_id'] = filters.status_id;
  }

  // Keep other filters with filters[] prefix (if needed)
  const otherFilters = { ...filters };
  delete otherFilters.status_id;

  Object.entries(otherFilters).forEach(([key, value]) => {
    if (value && value !== '') {
      params[`filters[${key}]`] = value;
    }
  });

  if (sort.sort_by) params['sort_by'] = sort.sort_by;
  if (sort.sort_direction) params['sort_direction'] = sort.sort_direction;
  if (noActivity.no_activity_since_days) {
    params['no_activity_since_days'] = noActivity.no_activity_since_days;
  }

  return params;
};